import { Component, OnInit, ViewChild } from '@angular/core';
import { DebitNote } from '../debit-note';
import { Subscription } from 'rxjs/Subscription';
import { TdSearchBoxComponent, ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdDialogService, TdLoadingService, ITdDataTableSortChangeEvent, IPageChangeEvent } from '@covalent/core';
import { Branch } from '../../accounting/branch';
import { Observable } from '../../../../../node_modules/rxjs/Observable';
import { SalesService } from '../sales.service';
import { SettingsService } from '../../../shared/services/settings.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ExportService } from '../../../shared/services/export.service';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-debit-note-list',
  templateUrl: './debit-note-list.component.html',
  styleUrls: ['./debit-note-list.component.scss']
})
export class DebitNoteListComponent implements OnInit {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: DebitNote[];
  subscription: Subscription = new Subscription();

  allBranches$: Observable<Branch[]>;
  branchFilter: string = 'ALL';

  columns: ITdDataTableColumn[] = [
    { name: 'order_number', label: 'Order #', tooltip: 'some tooltip example' },
    { name: 'type', label: 'Type' },
    { name: 'invoice_number', label: 'Invoice #' },
    { name: 'customer_name', label: 'Client' },
    { name: 'salesman', label: 'Salesman' },
    { name: 'order_date', label: 'Date' },
    { name: 'branch', label: 'Branch' },
    //{ name: 'branch_id', label: 'Branch ID' },
    { name: 'status', label: 'Status' }
  ];

  filteredData: any[] = [];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 50;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _salesService: SalesService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscription = this._salesService
      .getDebitNotes()
      .subscribe((debitnotes: DebitNote[]) => {
        console.log(debitnotes);
        this.data = debitnotes.filter((dn: DebitNote) => { return this._authService.getUserBranches().some((b: Branch) => { return b.id == dn['branch_id'] }) });;;
        this.filteredData = this.data;
        this.filteredTotal = this.data.length;
        //this.selectedRows = this.filteredData;
        this.filter();

        this._loadingService.resolve('loading');

      });

    //Use user's branches instead
    //this.allBranches$ = this._salesService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('debitnote')) {
      this._searchBox.value = this._settingsService.getSearchTerm('debitnote');
      this._searchBox.searchClicked();
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;
    this.sortBy = sortEvent.name;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('debitnote', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    // Need to filter by branch?
    if (this.branchFilter != 'ALL') {
      newData = newData.filter((d) => { return d['branch_code'] == this.branchFilter });
    }

    // Need to filter by status?
    /*if (this.statusFilter != 'ALL') {
      newData = newData.filter((d) => { return d['status'] == this.statusFilter });
    }*/


    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('debitnote'), true, excludedColumns);
    this.filteredTotal = newData.length;

    // Sort by date works differently
    if (this.sortBy == 'order_date') {
      newData = newData.sort(
        (d1, d2) => {
          return (new Date(d2[this.sortBy]).getTime() - new Date(d1[this.sortBy]).getTime()) * (this.sortOrder == TdDataTableSortingOrder.Ascending ? 1 : -1)
        }
      );
    } else {
      newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    }

    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

  total(data: any[], field: string) {
    if (!data) return;

    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b[field] || '0') }, 0);
  }

  openConfirm(): void {
    this._dialogService.openConfirm({
      message: 'Are you sure that you want to delete this item?',
      disableClose: false,
      title: 'Confirm',
    }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.selectedRows.forEach(
          (row: DebitNote) => {
              // Can delete if it hasn't been shipped
              if (row.status != 'SHIPPED'){
                this._salesService.deleteOneDebitNote(row.id + '').subscribe(
                  response => {
                    if (response['status'] == 'SUCCESS') {
                      // Remove this one
                      this._dialogService.openAlert(
                        {
                          title: 'SUCCESS',
                          message: 'Order Deleted ' + row.order_number
                        }
                      );
                      this.data = this.data.filter(d => { return d.id != row.id });
                      this.filter();
                    } else {
                      this._dialogService.openAlert(
                        {
                          title: 'WARNING',
                          message: 'Could not delete order ' + row.order_number
                        }
                      );
                    }
                  }
                )
              } else {
                // Cannot delete. Say why
                this._dialogService.openAlert(
                  {
                    title: 'WARNING',
                    message: 'Can not delete an order if it has been shipped'
                  }
                );
              }
            
          }
        );

      } else {
        // DO SOMETHING ELSE
      }
    });
  }

  selectAll() {
    let selected = !this.allSelected();

    if (selected) {
      this.filteredData.forEach(
        item => {
          this.select(true, item);
        }
      );
    } else {
      this.selectedRows = [];
    }

  }

  select(selected: boolean, row) {
    console.log(selected);

    if (selected) {
      if (!this.selectedRows.some(item => { return item.id == row.id })) {
        this.selectedRows.push(row);
      }
    } else {
      this.selectedRows = this.selectedRows.filter(item => { return item.id != row.id })
    }
  }

  allSelected() {
    // Are there as many selected as there are in the list?
    return this.filteredData.length == this.selectedRows.length;
  }

  rowSelected(row) {
    return this.selectedRows.some((selected) => { return selected.id == row.id });
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/sales/debit-note-list/debit-note-list.component.ts